import Parallax from "parallax-js";
import { initWowLibrary} from "@/scripts/helpers/wowAnimation";
import Stickyfill from "stickyfilljs";
import contactForm from "@/modules/blocks/contact-form/index";

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });

  parallaxInstance.friction(0.2, 0.2);
};

export const initParallaxMobile = () => {
  const tabletBreakpoint = 767;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    $(scene).each(function() {
      initParallaxDecorations($(this));
    });
  }
};

const sidebarList = () => {
  let lastId,
    sidebarMenu = $(".categories-list, .categories-select__list"),
    sidebarMenuHeight = sidebarMenu.outerHeight() + 15,

    menuItems = sidebarMenu.find("a"),

    scrollItems = menuItems.map(function () {
      let item = $($(this).attr("href"));
      if (item.length) {
        return item;
      }
    });

  menuItems.click(function (e) {
    let href = $(this).attr("href");
    let offsetTop = href === "#" ? 0 : $(href).offset().top - sidebarMenuHeight - 120;
    const tabletBreakpoint = 959;
    if ($(window).width() < tabletBreakpoint) {
      offsetTop = href === "#" ? 0 : $(href).offset().top - sidebarMenuHeight - 500;
    }
    $('html, body').stop().animate({
      scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $(window).scroll(function () {
    let fromTop = $(this).scrollTop() + 368;

    let currentMenuItem = scrollItems.map(function () {
      if ($(this).offset().top < fromTop)
        return this;
    });

    currentMenuItem = currentMenuItem[currentMenuItem.length - 1];
    let id = currentMenuItem && currentMenuItem.length ? currentMenuItem[0].id : "";

    if ($(this).scrollTop() < 80 || $(this).scrollTop() === 0) {
      $(".categories-list__item").first().addClass("is-active");
    }

    if (lastId !== id) {
      lastId = id;

      menuItems
        .parent().removeClass("is-active")
        .end().filter("[href='#" + id + "']").parent().addClass("is-active");
    }
  });
}

const selectDropdown = () => {
  $(".js-categories-select").on("click", function (e) {
    if (e.target !== this)
      return;
    $(".js-categories-select").toggleClass("is-open");
  });

  $(".categories-select__option").on("click", function (e) {
    e.stopPropagation();
    $(".js-categories-select").removeClass("is-open");
  });
}

$(document).ready(function() {
  initParallaxMobile();
  initWowLibrary();
  sidebarList();
  selectDropdown();
  Stickyfill.add($(".sidebar-wrapper"));
  contactForm();
});